<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.historyPage.title.default"
            small
            :canGoBack="true"
        ></TopBarBg>
        <PageContent
            class="flex-auto px-4"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0"
        >
            <TabNav
                v-model="tab"
                :items="tabs"
                :spaceNav="20"
                scrollable
                :fontBold="false"
                fontSize="text-sm"
                borderColorActive="border-primary"
                textColor="text-primary"
                textColorNoneActive="text-gray-secondary"
                paddingX="px-2"
                gap="mx-2"
                minWidth="50%"
                @update:modelValue="setTracking($event)"
            ></TabNav>
            <HistoryList
                ref="history-list"
                :initListConfig="purchaseListConfig"
                :initFilterConfig="purchaseFilterListConfig"
                :modalController="modalController"
                :selectedTab="tab"
                @onRefreshList="setupHistoryList()"
            ></HistoryList>
        </PageContent>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager";
//component
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
import TabNav from "@/components/Tab/TabNav.vue";
import HistoryList from "../component/HistoryList.vue";
//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import {
    PurchaseFilterConfigBuilder,
    PurchaseListConfigBuilder,
} from "@/core/History/config/HistoryConfigModel.js";
// import { HistoryPointConfigBuilder } from "@/core/Point/config/PointConfigModel.js";

export default {
    name: "History",
    mixins: [ModalMixin, AuthPageMixin, LocaleMixin],
    components: {
        TopBarBg,
        PageContent,
        TabNav,
        HistoryList,
    },
    data: function () {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,
            tab: 0,
            tabs: ["Redeemed", "Used / Expired"],
            isExpired: false,
            hasPoweredBy: false,
            trackingScreenName: "redeem_history",
        };
    },
    watch: {
        tab: function () {
            this.setupHistoryList();
        },
    },
    created: function () {
        this.setScrollLoadMore();
        this.setupHistoryList();
        this.tracking.screenName(this.trackingScreenName);
    },
    mounted: async function () {
        this.loadingModal.show();
        await this.$refs["history-list"].getList();
        this.loadingModal.hide();
    },
    beforeUnmount: function () {
        window.onscroll = null;
    },
    methods: {
        //#region mixin
        onSetupModalCompleted: function () {
            this.initialHistoryModal();
            this.initialRedeemModal();
        },
        //#endregion mixin
        setScrollLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },

        setupHistoryList: async function () {
            const configs = ConfigManager.getHistoryConfig();
            let config = this.tab == 0 ? configs.purchaseUnused : configs.purchaseUsed;
            this.purchaseListConfig = new PurchaseListConfigBuilder()
                .setConfigList(config)
                .setType("list")
                .setTop(25)
                .create();

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder().create();
            this.purchaseFilterListConfig = filterListConfig;

            if (this.$refs["history-list"]) {
                this.$refs["history-list"].reinitList(
                    this.purchaseListConfig,
                    this.purchaseFilterListConfig
                );
            }
        },

        loadMore: async function () {
            this.loadingModal.show();
            await this.$refs["history-list"].loadMore();
            this.loadingModal.hide();
        },

        setTracking: function (selectedTab) {
            let trackCategory = selectedTab == 0 ? "tab_redeemed" : "tab_used";
            let trackAction =
                selectedTab == 0 ? "click_tab_redeemed" : "click_tab_used";
            this.tracking.event(trackCategory, trackAction, null, null);
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
